export default "__VITE_ASSET__IHCeqnxe__"